import { Injectable } from '@angular/core';
import { BadRequestError, ResourceNotFoundError, ServerError } from 'app/trello/models/request-errors';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestErrorThrower {

  public throwError(
    error: any
  ) {
    if (error?.status === 404) {
      return throwError(() => new ResourceNotFoundError());

    } else if (error?.status >= 400 && error?.status <= 499) {
      return throwError(() => new BadRequestError());

    } else {
      return throwError(() => new ServerError());
    }
  }

}
